import React, { useEffect } from "react";
import axios from "axios";
import "../../App.css";

function GetSnapRankings({ setData, route }) {
  useEffect(() => {
    axios
      .get(route)
      .then((response) => setData(response.data))
      .catch((error) => console.error("Error fetching snap rankings:", error));
  }, [route, setData]);

  return null; // This just fetches data, no UI needed
}

export default GetSnapRankings;
